import React from 'react'
import styles from './styles.css'
import clsx from 'clsx'

import Progress from 'containers/App/Progress'

import {Loader} from 'rambler-ui'

export const SuspenseFallback = ({
  withoutBorder = false,
  fullPageProgress = false
}) => (
  <div
    className={clsx(
      styles.fallback,
      withoutBorder && styles.withoutBorder,
      fullPageProgress && styles.fullPage
    )}>
    {fullPageProgress ? <Progress /> : <Loader loading />}
  </div>
)
